import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Pasás horas buscando ideas en Pinterest, grupos o PDFs sueltos.', 'Improvisás sesiones porque no sabés bien por dónde empezar.', 'Terminás haciendo informes y devoluciones desde cero, una y otra vez.', 'Sentís que tenés recursos sueltos, dispersos y desordenados.', 'Usás materiales que no siempre se adaptan al nivel o a la dificultad del niño.', 'El seguimiento se vuelve improvisación + intuición + culpa.', 'Llegás cansada y todavía te queda planificar y redactar observaciones.'];
  return <section className="pt-8 pb-12 bg-surface" data-id="element-196">
      <div className="max-w-4xl mx-auto px-4" data-id="element-197">
        <FadeIn data-id="element-198">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-6 text-center text-mint" data-id="element-199">
            Si sos psicopedagoga o docente, esto te va a sonar familiar:
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-4" data-id="element-200">
          {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex items-start gap-4 bg-white/5 p-4 rounded-lg border border-red-500/20" data-id="element-201">
              <XCircle className="text-red-400 shrink-0 mt-0.5" size={24} data-id="element-202" />
              <p className="text-lg md:text-xl font-medium text-white" data-id="element-203">
                {point}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-204">
          <p className="text-center text-2xl md:text-3xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-[#F5C6A0]" data-id="element-205">
            ¿Cuántas tardes más vas a sacrificar armando material desde cero?
          </p>
        </FadeIn>
      </div>
    </section>;
}